@if (config) {
  <div class="highlight">
    <div class="chart" [style.--mainColor]="selectedElement.color">
      <div class="donut-chart" [id]="id"></div>
      <div class="indicator">
        <div class="quantity">{{ indicator }}</div>
        <div class="subtitle">{{ selectedElement.indicatorSubtitle }}</div>
      </div>
    </div>
  </div>
}